import IconEnvelopeSolid from '@/assets/icons/font_awesome/envelope-solid.svg?react';
import IconShareNodesSolid from '@/assets/icons/font_awesome/share-nodes-solid.svg?react';
import { UI_PRIMITIVE__tabs_content } from '@/components/ui/UI_PRIMITIVE__tabs';
import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { useState } from 'react';
import { LayoutMobile } from '../../layouts/LayoutMobile';
import { LayoutPageMobileWithTabs } from '../../layouts/LayoutPageMobileWithTabs';
import { A_PAGE_LAYOUT__desktop } from './A_PAGE_LAYOUT__desktop';
import { A_LAYOUT__email_not_verified } from './views/A_LAYOUT__email_not_verified';
import { ViewEnterWithEmail } from './views/ViewEnterWithEmail';
import { ViewEnterWithSocialNetworks } from './views/ViewEnterWithSocialNetworks';
import { ViewMagicLinkSent } from './views/ViewMagicLinkSent';
import { WATCHER__navigate_after_login } from './watchers/WATCHER__navigate_after_login';
import { WATCHER__auto_login } from './watchers/WatcherAutoLogin';

export function A_PAGE__auth() {
  const dispatch = use_dispatch();

  const { auth_token, is_authorized } = use_slice_user(['auth_token', 'is_authorized']);
  const { is_all_data_loaded } = use_slice_workspace(['is_all_data_loaded']);
  const { page_auth_show_email_is_not_verified, page_auth_show_magic_link_sent, global_is_mobile } = use_slice_ui([
    'page_auth_show_email_is_not_verified',
    'page_auth_show_magic_link_sent',
    'global_is_mobile',
  ]);

  const [active_tab, set_active_tab] = useState(EPagesMobileTabs.AUTH_EMAIL);

  /*
   * EFFECTS
   */
  //need to hide splash
  use_effect(() => {
    if (auth_token != '') return; //can be authorized
    if (is_authorized) return; //authorized

    //this use_effect conflicts with autologin
    if (CONSTANTS__environment_client.VITE_AUTH_AUTOLOGIN_BOOLEAN) return;

    void dispatch(LOCAL__workspace_set_is_all_data_loaded(true));
  }, [auth_token]);

  /*
   * RENDERS
   */

  // todo: move to component
  function render_view_mobile_tab_email() {
    if (page_auth_show_email_is_not_verified) {
      return (
        <LayoutMobile>
          <A_LAYOUT__email_not_verified />
        </LayoutMobile>
      );
    } else if (page_auth_show_magic_link_sent) {
      return (
        <LayoutMobile>
          <ViewMagicLinkSent />
        </LayoutMobile>
      );
    } else {
      return (
        <LayoutPageMobileWithTabs
          tabs={[EPagesMobileTabs.AUTH_EMAIL, EPagesMobileTabs.AUTH_SOCIAL]}
          icons={[<IconEnvelopeSolid />, <IconShareNodesSolid />]}
          activeTab={active_tab}
          setActiveTab={set_active_tab}
        >
          <UI_PRIMITIVE__tabs_content className="mt-5" value={EPagesMobileTabs.AUTH_EMAIL}>
            <ViewEnterWithEmail />
          </UI_PRIMITIVE__tabs_content>
          <UI_PRIMITIVE__tabs_content className="mt-5" value={EPagesMobileTabs.AUTH_SOCIAL}>
            <ViewEnterWithSocialNetworks />
          </UI_PRIMITIVE__tabs_content>
        </LayoutPageMobileWithTabs>
      );
    }
  }

  function render_page(_: boolean) {
    let out = <></>;

    if (global_is_mobile) {
      out = <>{render_view_mobile_tab_email()}</>;
    } else {
      out = <A_PAGE_LAYOUT__desktop />;
    }

    return out;
  }

  return (
    <>
      <WATCHER__auto_login />
      <WATCHER__navigate_after_login />

      {render_page(is_all_data_loaded)}
    </>
  );
}
